import { UnauthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { FC, useEffect } from 'react';

import { login } from '../../features';

import styles from './login.module.scss';
import logo from './logo.svg';
import buttonIcon from './buttonIcon.svg';
import { InteractionStatus } from '@azure/msal-browser';
import { useNavigate } from 'react-router-dom';

const Login: FC = () => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && inProgress === InteractionStatus.None) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, inProgress, navigate]);

  const handleLogin = () => {
    login();
  };

  if (isAuthenticated) {
    return <div>Redirecting...</div>;
  }

  return (
    <div className={styles.page}>
      <div className={styles.loginBox}>
        <div className={styles.body}>
          <img src={logo} alt='UMOJO Logo' className={styles.logo} />
        </div>
        <UnauthenticatedTemplate>
          <button className={styles.loginButton} onClick={handleLogin}>
            <img src={buttonIcon} alt='' className={styles.buttonIcon} />
            Login
          </button>
        </UnauthenticatedTemplate>
      </div>
    </div>
  );
};

export default Login;
